interface CartItem {
    id: number;
    quantity: number;
    item_id: number;
    customer_id: number;
  }
  

interface CartBook {
    item_id: number;
    book_id: number;
    book_title: string;
    author_name: string;
    book_price: number;
    book_cover_path: string;
    book_quantity: number;
    stock: number; 
 }
  

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

export async function fetchBooks(id: number) {
    return fetch(`${BASE_URL}/books/${id}`)
}

export async function fetchAuthors(id: number) {
    return fetch(`${process.env.REACT_APP_BASE_API_URL}/authors/${id}`);
}


export async function processBooksData(cartItems: CartItem[]) {
    const booksData: CartBook[] = [];
    for (const item of cartItems) {
        try {
          const resBook = await fetchBooks(item.id);
          if (!resBook.ok) continue;
          
          const bookDetails = await resBook.json();
          
          const resAuthor = await fetchAuthors(bookDetails.author_id);
          if (!resAuthor.ok) continue;
          
          const authorData = await resAuthor.json();
          
          booksData.push({
            item_id: item.item_id,
            book_id: item.id,
            book_title: bookDetails.book_title,
            author_name: authorData.author_name,
            book_price: bookDetails.book_price,
            book_cover_path: bookDetails.book_cover_path,
            book_quantity: item.quantity,
            stock: bookDetails.book_quantity
          });


        } catch (bookError) {
            console.error(`Помилка завантаження книги ${item.id}:`, bookError);
        }
    }
    return booksData;
}
